import React, { useEffect } from 'react';
import './Toast.css';

const Toast = ({ message, type = 'info', onClose }) => {
    
    // Cerrar automáticamente después de 3 segundos
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 3000);

        return () => clearTimeout(timer);
    }, [onClose]);

    // Iconos según el tipo
    const icons = {
        success: '✅',
        error: '❌',
        info: 'ℹ️',
        warning: '⚠️'
    };

    return (
        <div className="toast-container">
            <div className={`toast ${type}`} onClick={onClose}>
                <span className="toast-icon">{icons[type]}</span>
                <span className="toast-message">{message}</span>
            </div>
        </div>
    );
};

export default Toast;